import type { TransitionConfig } from 'svelte/transition';

export type TransitionTuple<Config> = [
    (node: Element, config: Config) => TransitionConfig,
    Config,
];

export type TransitionsInOut<In, Out> = {
    in?: TransitionTuple<In>;
    out?: TransitionTuple<Out>;
};

export function none(_node: Element, _options: unknown): TransitionConfig {
    return {};
}

export function readTransitions<TransitionInOptions, TransitionOutOptions>(transitions: {
    in?: TransitionTuple<TransitionInOptions> | null;
    out?: TransitionTuple<TransitionOutOptions> | null;
}): {
    inFunc: ((node: Element, options: TransitionInOptions) => TransitionConfig) | null;
    inOptions: TransitionInOptions;
    outFunc: ((node: Element, options: TransitionOutOptions) => TransitionConfig) | null;
    outOptions: TransitionOutOptions;
} {
    let [inFunc, inOptions] = transitions.in ?? [null, {} as TransitionInOptions];
    let [outFunc, outOptions] = transitions.out ?? [null, {} as TransitionOutOptions];

    return {
        inFunc,
        inOptions,
        outFunc,
        outOptions,
    };
}
